import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import {EndMeetingResponse, KickUserResponse, UserOnGoingMeeting} from '../types/meeting';
import { Observable } from 'rxjs';
import { ZIMSDK } from 'zego-zim-web';
import { ZimService } from '../../../services/zim.service';
import { MEETING_TYPE, STATUS_INVITE_MEMBER } from '../../../constants/until';
import { getUserInfo } from '../../../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {
  private apiService = inject(ApiService);
  private zimService = inject(ZimService);

  zimEngine: ZIMSDK | null = null;

  private _acceptedMeeting = signal<string>("");
  readonly acceptedMeeting = this._acceptedMeeting.asReadonly();

  userID: string = "";
  userName: string = "";

  constructor() {
    this.zimEngine = this.zimService.getZIM();
    const userInfo = getUserInfo();
    if (userInfo) {
      this.userID = userInfo.phoneNumber;
      this.userName = userInfo.username || userInfo.phoneNumber;
    }
  }

  kickUser(meetingId: string, userKickIds: string[], reason: string = 'Vi phạm nội quy cuộc hop'): Observable<KickUserResponse> {
    return this.apiService.post<KickUserResponse>('/meeting/zego-cloud-meeting/kick-user-meeting', { meetingId, userKickIds, reason }, {})
  }

  endMeeting(meetingId: string): Observable<EndMeetingResponse> {
    return this.apiService.post<EndMeetingResponse>('/meeting/zego-cloud-meeting/end-meeting', { meetingId }, {})
  }

  editMeeting(meetingId: string, hostId: string = "", hostName: string = "", adminIds: string[], isPublic: MEETING_TYPE) {
    return this.apiService.post<any>('/meeting/zego-cloud-meeting/edit-meeting', { meetingId, hostId, hostName, adminIds, isPublic }, {});
  }

  getOngoingRooms(): Observable<UserOnGoingMeeting> {
    return this.apiService.get<UserOnGoingMeeting>('/meeting/room/users/ongoing-meeting')
  }

  async acceptJoin(userID: string): Promise<boolean> {
    if (this.zimEngine) {
      const messageObj = {
        type: 2,
        message: STATUS_INVITE_MEMBER.JOIN_MEET_ACCEPT
      };
      const config = {
        priority: 3, // Set priority for the message. 1: Low (by default). 2: Medium. 3: High.
      };
      try {
        await this.zimEngine.sendMessage(messageObj, userID, 0, config);
        return true;
      } catch (error) {
        console.error("Accept join error", error);
        return false;
      }
    }
    return false;
  }

  async rejectJoin(userID: string): Promise<boolean> {
    if (this.zimEngine) {
      const messageObj = {
        type: 2,
        message: STATUS_INVITE_MEMBER.JOIN_MEET_REJECT
      };
      const config = {
        priority: 3, // Set priority for the message. 1: Low (by default). 2: Medium. 3: High.
      };
      try {
        await this.zimEngine.sendMessage(messageObj, userID, 0, config);
        return true;
      } catch (error) {
        console.error("Reject join error", error);
        return false;
      }
    }
    return false;
  }

  clearAcceptedMeeting() {
    this._acceptedMeeting.set("");
  }

  updateAcceptedMeeting(meetingId: string) {
    this._acceptedMeeting.set(meetingId);
  }
}
